import { each } from 'lodash'
import { app, menu, search, modal } from '../../utils/store'
import { activate, deactivate } from '../../utils/states'
import { media } from '../../utils/media'
import { injectScript } from '../../utils/dom'
import { getCookie, setCookie } from '../../utils/cookies'

export default class Modal {
    constructor() {
        this.urlParameters = new URLSearchParams(window.location.search)

        this.main = {
            toggler: document.getElementById('menu-toggler'),
            logo: document.getElementById('logo'),
        }
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu')
        }

        this.search = {
            input: document.getElementById('global-search'),
            toggler: document.getElementById('search-toggler'),
        }

        this.modal = {
            el: document.querySelectorAll('[data-modal]'),
            toggler: document.querySelectorAll('.btn-modal'),
            close_modal: document.getElementById('close-modal'),
        }

        this.configurator = {
            init: false,
            ambient: null,
            active: this.urlParameters.get('configurator'),
            container: null,
        }

        this.virtualtour = {
            init: false,
            active: this.urlParameters.get('virtualtour')
        }

        this.body = document.body

        this.toggle()

        // Product page: ?configurator=true
        if (this.configurator.active) {
            this.openConfiguratorModal({
                ambient: false,
                modalId: 'configurator-modal',
            })
        }

        // Configurator page: open ambient viewer after load
        if (document.body.hasAttribute('data-open-configurator-ambient')) {
            this.openConfiguratorModal({
                ambient: true,
                modalId: 'configurator-complete-modal',
            })
        }

        console.log(this.virtualtour)

        if (this.virtualtour.active) {
            modal.current = document.querySelector(`[id="${this.virtualtour.active}"]`)
            modal.isOpen = true
            if (!this.virtualtour.init) {
                this.createVirtualTour()
            }
        }
    }

    isConfiguratorModal = (el) => {
        return el && (
            el.hasAttribute('data-modal-configurator') ||
            el.hasAttribute('data-modal-configurator-complete')
        )
    }

    openConfiguratorModal = ({ ambient = false, modalId = null } = {}) => {
        const id = modalId || (ambient ? 'configurator-complete-modal' : 'configurator-modal')
        const target = document.querySelector(`[id="${id}"]`)

        if (!target) {
            console.error(`Configurator modal not found: ${id}`)
            return
        }

        modal.isOpen = true
        modal.current = target

        activate(this.main.toggler)
        activate(modal.current)
        activate(this.search.toggler)
        deactivate(app.header)
        deactivate(document.getElementById('login-reserved'))
        deactivate(document.querySelector('[data-menu-products]'))
        deactivate(document.querySelector('[data-menu-actions]'))
        deactivate(document.querySelector('[data-menu-store]'))
        deactivate(document.querySelector('[data-menu-contract]'))
        document.body.classList.add('overflow-hidden')
        document.body.classList.add('modal-active')

        app.header.classList.add('inverted')
        menu.current = undefined
        menu.isOpen = false
        deactivate(document.getElementById('main-menu'))

        this.destroy3Dviewer()
        this.create3Dviewer({ ambient })
    }

    toggle() {
        each(this.modal.toggler, (toggler) => {
            toggler.addEventListener('click', (event) => {
                event.stopPropagation()
                var data_modal = event.currentTarget.getAttribute('data-target')

                event.preventDefault()

                // Configurator: shared open path (product vs ambient)
                if (
                    data_modal === 'configurator-modal' ||
                    data_modal === 'configurator-complete-modal'
                ) {
                    const ambient =
                        event.currentTarget.getAttribute('data-toggle-configurator') === 'AMBIENTI_EMPTY' ||
                        data_modal === 'configurator-complete-modal'

                    this.openConfiguratorModal({ ambient, modalId: data_modal })
                    return
                }

                modal.isOpen = true
                modal.current = document.querySelector('[id="' + data_modal + '"]')

                activate(this.main.toggler)
                activate(modal.current)
                activate(this.search.toggler)
                deactivate(app.header)
                deactivate(document.getElementById('login-reserved'))
                deactivate(document.querySelector('[data-menu-products]'))
                deactivate(document.querySelector('[data-menu-actions]'))
                deactivate(document.querySelector('[data-menu-store]'))
                deactivate(document.querySelector('[data-menu-contract]'))
                document.body.classList.add('overflow-hidden')
                document.body.classList.add('modal-active')

                // If Modal 'Video'
                if (modal.current.hasAttribute('data-modal-video')) {
                    modal.current.querySelector('video').play()
                }

                // If Modal 'Form'
                if (media('<iPadLandscape') && (modal.current.hasAttribute('data-modal-form') || modal.current.hasAttribute('data-modal-advertising'))) {
                    app.header.classList.add('inverted')
                }

                if (event.target.parentNode.parentNode.id == 'active-newsletter') {
                    deactivate(event.target.parentNode.parentNode),
                        setCookie('newsletter-banner', 'true', 1)
                }

                if (event.target.parentNode.parentNode.id == 'active-promotions') {
                    deactivate(event.target.parentNode.parentNode),
                        setCookie('promo-2', 'true', 1)
                }
            })
        })

        if (this.menu.toggler) {
            this.menu.toggler.addEventListener('click', (event) => {
                if (modal.isOpen) {
                    // Destroy configurator before closing so the next open can recreate ambient or product
                    if (this.isConfiguratorModal(modal.current)) {
                        this.destroy3Dviewer()
                        app.header.classList.remove('inverted')
                        app.header.classList.remove('reverted')
                    }

                    deactivate(modal.current)
                    deactivate(this.main.toggler)
                    deactivate(this.search.toggler)
                    activate(app.header)
                    activate(document.getElementById('login-reserved'))
                    activate(document.querySelector('[data-menu-products]'))
                    activate(document.querySelector('[data-menu-actions]'))
                    activate(document.querySelector('[data-menu-store]'))
                    activate(document.querySelector('[data-menu-contract]'))

                    document.body.classList.remove('overflow-hidden')
                    document.body.classList.remove('modal-active')

                    // If Modal 'Video'
                    if (modal.current.hasAttribute('data-modal-video')) {
                        modal.current.querySelector('video').pause()
                        modal.current.querySelector('video').currentTime = 0
                    }

                    // If Modal 'Form'
                    if (media('<iPadLandscape') && (modal.current.hasAttribute('data-modal-form') || modal.current.hasAttribute('data-modal-advertising'))) {
                        app.header.classList.remove('inverted')
                    }

                    modal.current = undefined
                    modal.isOpen = false
                }
            })
        }
    }

    createVirtualTour = () => {
        activate(this.main.toggler)
        activate(modal.current)
        activate(this.search.toggler)
        deactivate(app.header)
        deactivate(document.getElementById('login-reserved'))
        deactivate(document.querySelector('[data-menu-products]'))
        deactivate(document.querySelector('[data-menu-actions]'))
        deactivate(document.querySelector('[data-menu-store]'))
        deactivate(document.querySelector('[data-menu-contract]'))
        document.body.classList.add('overflow-hidden')
        document.body.classList.add('modal-active')
    }

    destroy3Dviewer = () => {
        const container = this.configurator.container
            || (modal.current && modal.current.querySelector('[data-configurator-async]'))
            || document.querySelector('[data-configurator-async]')

        if (container) {
            container.innerHTML = ''
        }

        // Cleanup nodes that may sit outside the async container
        ;['modelviewer3d-container', 'modelviewer3d-ui-selector', 'modelviewer3d-browser', 'modelviewer3d-loading', 'configuratore']
            .forEach((id) => {
                const el = document.getElementById(id)
                if (el) el.remove()
            })

        this.configurator.init = false
        this.configurator.ambient = null
        this.configurator.container = null
    }

    create3Dviewer = ({ ambient = false } = {}) => {
        app.page = document.body.getAttribute('data-template')
        app.sku = document.body.getAttribute('data-sku')

        // Mount into the currently open modal
        const liveContainer = modal.current
            ? modal.current.querySelector('[data-configurator-async]')
            : document.querySelector('[data-configurator-async]')

        if (!liveContainer) {
            console.error('Configurator container not found')
            return
        }

        this.configurator.container = liveContainer
        this.configurator.ambient = ambient

        let configurator = document.createElement('div')
        let loading = document.createElement('div')
        let selector = document.createElement('p')

        let family = this.configurator.container.getAttribute('data-configurator-async')

        this.configurator.container.append(configurator)

        configurator.id = 'modelviewer3d-container'
        loading.id = 'modelviewer3d-loading'
        selector.id = 'modelviewer3d-ui-selector'

        configurator.append(loading)

        configurator.width = 1400
        configurator.height = 600
        configurator.setAttribute('width', configurator.width)
        configurator.setAttribute('height', configurator.height)
        configurator.setAttribute('data-root', 'https://bontempi.azurewebsites.net/')
        configurator.setAttribute('data-background-color', '0xffffff')
        configurator.setAttribute('data-language', app.language)

        if (ambient) {
            configurator.setAttribute('data-id', 'AMBIENTI_EMPTY')
        } else if (family !== '' && family !== null) {
            configurator.setAttribute('data-family-definition', family)
        } else if (app.sku) {
            // Product-specific configurator: keep the SKU
            configurator.setAttribute('data-id', app.sku)
        }

        configurator.setAttribute('data-country', 'it')

        selector.width = 1400

        if (!app.device.desktop && !app.device.tablet) {
            let message = {
                title: {
                    it: "Per un'esperienza ottimale, usa il configuratore d’ambiente Bontempi dal tuo computer.\n\nVuoi procedere ugualmente configurando un singolo prodotto?",
                    en: "For the best experience, explore the Bontempi multi-product configurator on your desktop.\n\nWant to configure a single product anyway?",
                    fr: "Pour une expérience optimale, explorez le configurateur d'ambiance Bontempi depuis votre ordinateur.\n\nVous souhaitez configurer un seul produit de toutes façons?",
                    de: "Für das beste Erlebnis empfehlen wir, den Bontempi Raumkonfigurator am Computer zu nutzen.\n\nMöchten Sie stattdessen ein einzelnes Produkt allesamt konfigurieren?",
                    es: "Para una experiencia óptima, explora el configurador de ambientes Bontempi desde tu ordenador.\n\n¿Quieres configurar un solo producto de todas formas?",
                    ru: "Для наилучшего результата используйте конфигуратор интерьера Bontempi на компьютере.\n\nХотите настроить отдельный продукт все равно?",
                },
                button: {
                    it: "Continua",
                    en: "Continue",
                    fr: "Continuer",
                    de: "Weiter",
                    es: "Continuar",
                    ru: "Продолжить",
                }
            }

            console.log(message, app.language)

            let disclaimer = document.createElement('div')
            disclaimer.innerHTML = message.title[app.language]
            disclaimer.classList = 'disclaimer'

            let button = document.createElement('button')
            button.innerHTML = message.button[app.language]
            button.classList = 'btn-chip'
            button.onclick = () => {
                configurator.removeChild(disclaimer)
                configurator.parentNode.append(selector)
                this.initModel3D(configurator)
            }

            disclaimer.append(button)
            configurator.append(disclaimer)
        } else {
            configurator.parentNode.append(selector)
            this.initModel3D(configurator)
        }
    }

    injectScriptOnce = async (src, appendTo) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            return
        }
        await injectScript(src, appendTo || document.head)
    }

    initModel3D = async (appendTo) => {
        await this.injectScriptOnce('https://bontempi.azurewebsites.net/viewer/js/three.min.js', appendTo)
        await this.injectScriptOnce('https://bontempi.azurewebsites.net/viewer/js/loaders/OBJLoader.js', appendTo)
        await this.injectScriptOnce('https://bontempi.azurewebsites.net/viewer/js/controls/OrbitControls.js', appendTo)
        await this.injectScriptOnce('https://bontempi.azurewebsites.net/viewer/js/modelviewer/modelviewer.min.js', appendTo)
        await this.ModelViewer3d()

        this.configurator.init = true
    }

    ModelViewer3d = () => {
        const DEFAULT_CONFIGURATION = "bontempi",
            version = "0.9.0",
            REDIRECT_DATAROOT = {
                "https://bontempi.azurewebsites.net/": "https://bontempistorage.z6.web.core.windows.net/",
                "https://bontempihk.azurewebsites.net/": "https://bontempihkstorage.z7.web.core.windows.net/"
            },
            CONFIGURATIONS = {
                "https://bontempi.azurewebsites.net/": "bontempi",
                "https://bontempihk.azurewebsites.net/": "bontempihk"
            }

        function getUrlParameter(name, url) {
            url || (url = window.location.href), name = name.replace(/[\[\]]/g, "\\$&")
            var regex, results = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)").exec(url)
            return results ? results[2] ? decodeURIComponent(results[2].replace(/\+/g, " ")) : "" : null
        }

        function getParameter(container, param, urlParam) {
            let result = urlParam ? getUrlParameter(urlParam) : null
            return !result && container && container.hasAttribute(param) && (result = container.getAttribute(param)), result
        }

        function addScript(url, waitForCompletion) {
            return new Promise((function (resolve, reject) {
                var existing = document.querySelector(`script[src="${url}"], script[src^="${url}"]`)
                if (existing) {
                    return resolve(url)
                }

                var script = document.createElement("script")
                script.type = "text/javascript",
                    script.src = url,
                    script.async = !0,
                    waitForCompletion && (script.onload = function () {
                        resolve(url)
                    }, script.onerror = function (error) {
                        reject(url + " failed to load: " + error)
                    }), document.querySelector("head").appendChild(script), waitForCompletion || resolve(url)
            }))
        }

        function addWebComponent(configuration, dataRoot) {
            if (container) {
                let language = getParameter(container, "data-language", "lang"),
                    country = getParameter(container, "data-country"),
                    modelId = getParameter(container, "data-id", "id")
                modelId || (modelId = getParameter(container, "data-model-id", "model"))
                let familyId = getParameter(container, "data-family-definition", "family"),
                    pricelist = getParameter(container, "pricelist"),
                    clearColor = getParameter(container, "data-background-color"),
                    viewerWidth = getParameter(container, "width") || 0,
                    viewerHeight = getParameter(container, "height"),
                    browserWidth = getParameter(browserContainer, "width") || 0,
                    uiWidth = getParameter(uiContainer, "width") || 0,
                    wcNode = document.createElement("ubisive-configuratore")
                wcNode.id = "configuratore", wcNode.setAttribute("configuration", configuration), language && wcNode.setAttribute("language", language), country && wcNode.setAttribute("country", country), dataRoot && wcNode.setAttribute("data-root", dataRoot), familyId && wcNode.setAttribute("family-id", familyId), modelId && wcNode.setAttribute("model-id", modelId), browserContainer && !modelId && wcNode.setAttribute("show-browser", !0), pricelist && wcNode.setAttribute("pricelist", pricelist), clearColor && wcNode.setAttribute("clear-color", clearColor), uiWidth && wcNode.setAttribute("requested-width", uiWidth), browserWidth && wcNode.setAttribute("requested-browser-width", browserWidth), viewerWidth && wcNode.setAttribute("requested-viewer-width", viewerWidth)
                let maxWidth = Math.max(viewerWidth, browserWidth, uiWidth)
                maxWidth > 0 && (wcNode.style.width = maxWidth + "px"), container.appendChild(wcNode)
            }
        }

        function addVersionToUrl(originalUrl, versionNumber) {
            return null == originalUrl ? null : (null != versionNumber && null != versionNumber || (versionNumber = filesVersion), originalUrl.indexOf("?") >= 0 ? originalUrl + "&ver=" + versionNumber : originalUrl + "?ver=" + versionNumber)
        }

        var container, browserContainer, uiContainer, dataRoot

        function injectNewConfigurator() {
            console.log('Inject Configurator')

            if (!(container = document.getElementById("modelviewer3d-container"))) {
                return void console.error("modelviewer3d-container element not found")
            }

            browserContainer = document.getElementById("modelviewer3d-browser"),
                uiContainer = document.getElementById("modelviewer3d-ui-selector"),
                dataRoot = getParameter(container, "data-root")

            let configuration = "bontempi"

            CONFIGURATIONS && CONFIGURATIONS[dataRoot] && (configuration = CONFIGURATIONS[dataRoot]),
                REDIRECT_DATAROOT && REDIRECT_DATAROOT[dataRoot] && (dataRoot = REDIRECT_DATAROOT[dataRoot])

            let webComponentUrl = `${dataRoot}js/dist/ubisive-configuratore.min.js`
            webComponentUrl = addVersionToUrl(webComponentUrl, "0.9.0")

            // Custom element already registered from a previous open
            if (window.customElements && customElements.get('ubisive-configuratore')) {
                addWebComponent(configuration, dataRoot)
                return
            }

            addScript(webComponentUrl, !0).then(url => {
                console.debug(`Script Loaded: ${url}`), addWebComponent(configuration, dataRoot)
            }).catch(err => {
                console.error(err)
            })
        }

        injectNewConfigurator()
    }
}
